import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'

import { Center, Grid, Tooltip } from '@chakra-ui/react'

interface EditRemoveButtonIProps {
  handleOnEdit: () => void
  handleOnDelete?: () => void
  showEdit?: boolean
  showDelete?: boolean
  disabled?: boolean
  disabledTooltip?: string
}

export const EditRemoveButton = ({
  handleOnEdit,
  handleOnDelete,
  showEdit = true,
  showDelete = true,
  disabled = false,
  disabledTooltip,
}: EditRemoveButtonIProps) => {
  const content = (
    <Grid
      gap='10px'
      gridTemplateRows={showDelete ? '1fr 1fr' : '1fr'}
      h='full'
      maxW='100%'
      ml='10px'
    >
      {showEdit && (
        <Center
          _hover={disabled ? {} : { bgColor: '#d2d2d4' }}
          bgColor='#E5E8EE'
          boxShadow={disabled ? 'none' : '0 2px 7px 0 rgba(50,121,199,0.5)'}
          cursor={disabled ? 'not-allowed' : 'pointer'}
          data-testid={`EditRemoveButton:edit${disabled ? '-disabled' : ''}`}
          h='full'
          onClick={disabled ? undefined : handleOnEdit}
          opacity={disabled ? 0.5 : 1}
          rounded='5px'
          transition='ease-in-out'
          transitionDuration='300ms'
          transitionProperty='background-color'
          w='60px'
        >
          <HiOutlinePencil color='#3279C7' size='24px' />
        </Center>
      )}
      {showDelete && (
        <Center
          _hover={disabled ? {} : { bgColor: '#b40e2a' }}
          bgColor='#D01030'
          boxShadow={disabled ? 'none' : '0 2px 7px 0 rgba(189,25,25,0.5)'}
          cursor={disabled ? 'not-allowed' : 'pointer'}
          data-testid={`EditRemoveButton:delete${disabled ? '-disabled' : ''}`}
          h='full'
          onClick={disabled ? undefined : handleOnDelete}
          opacity={disabled ? 0.5 : 1}
          rounded='5px'
          transition='ease-in-out'
          transitionDuration='300ms'
          transitionProperty='background-color'
          w='60px'
        >
          <HiOutlineTrash color='#fff' size='24px' />
        </Center>
      )}
    </Grid>
  )

  if (disabled && disabledTooltip) {
    return (
      <Tooltip hasArrow label={disabledTooltip} placement='left'>
        {content}
      </Tooltip>
    )
  }

  return content
}
